<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-card>
      <div slot="header" class="title">
        <span>佣金规则</span>
      </div>
      <SiruiSearch
        :query="baseFormData"
        :columns="formColumn"
        :isQueryPanel="false"
        :isDisabledForm="true"
      ></SiruiSearch>
      <div class="commission-box">
        <div class="commission-title">佣金规则</div>
        <vxe-table
          border
          show-overflow
          resizable
          size="mini"
          align="center"
          :auto-resize="true"
          :data="commissionRuleData"
        >
          <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
          <vxe-table-column field="ruleDepartmentName" title="部门"> </vxe-table-column>
          <vxe-table-column field="roleName" title="角色"> </vxe-table-column>
          <vxe-table-column field="rule" title="规则"> </vxe-table-column>
          <!-- <vxe-table-column field="monthNumber" title="时间"> </vxe-table-column>
          <vxe-table-column field="percentage" title="百分比"> </vxe-table-column> -->
        </vxe-table>
        <vxe-table
          border
          show-overflow
          resizable
          size="mini"
          align="center"
          style="margin-top: 20px"
          :auto-resize="true"
          :data="commissionTableData"
        >
          <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
          <vxe-table-column field="spaceAssetName" title="资产"> </vxe-table-column>
          <vxe-table-column field="spaceUnitName" title="单元"> </vxe-table-column>
          <vxe-table-column field="spaceFloorName" title="楼层"> </vxe-table-column>
          <vxe-table-column field="spaceName" title="房号"> </vxe-table-column>
        </vxe-table>
      </div>
    </el-card>
    <el-card style="margin-top: 20px" v-if="operateType === 'detail'">
      <div slot="header" class="title">
        <span>审核记录</span>
      </div>
      <sirui-table
        ref="siruiTable"
        :data="auditRecordData"
        :paging="false"
        :setting="false"
        :customVisible="false"
        :columns="searchColumn"
        :height="300"
      >
        <!-- <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column> -->
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in searchColumn"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </el-card>
    <el-card style="margin-top: 20px" v-if="operateType === 'audit'">
      <div slot="header" class="title">
        <span>审批信息</span>
      </div>
      <el-form :model="auditInfo" :rules="rules" label-width="80px" label-position="right">
        <el-form-item label="审批信息" prop="info">
          <el-input
            v-model="auditInfo.info"
            placeholder="请输入"
            clearable
            maxlength="50"
            minlength="2"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="btns">
      <el-button type="primary" @click="approval" v-if="operateType === 'audit'">通过</el-button>
      <el-button type="primary" @click="reject" v-if="operateType === 'audit'">驳回</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-card>
</template>

<script>
  import API from '@/api/intermodality/commission';
  import XEUtils from 'xe-utils';
  import { auditStatusList, effectiveStatusList } from '../data';
  export default {
    name: 'commissionDetail',
    mixins: [],
    components: {},
    created() {
      this.id = this.$route.query.id;
      if (this.id) {
        this.getRuleDetail(this.id);
      }
    },
    mounted() {},
    data() {
      return {
        loading: false,
        baseFormData: {
          ruleNo: '',
          ruleCompanyName: '',
          ruleName: '',
          validDate: '',
          auditStatus: '',
          effectiveStatus: '',
          remark: '',
          createPersonName: '',
        },
        commissionTableData: [],
        commissionRuleData: [],
        auditInfo: {
          info: '',
        },
        rules: {
          info: [{ required: true, message: '请填写审核信息', trigger: ['blur', 'change'] }],
        },
        id: '',
        auditStatusList,
        effectiveStatusList,
        auditRecordData: [],
        searchColumn: [
          {
            field: 'optUserName',
            title: '操作人',
            visible: true,
          },
          {
            field: 'optType',
            title: '操作',
            visible: true,
          },
          {
            field: 'optTime',
            title: '操作时间',
            visible: true,
          },
          {
            field: 'info',
            title: '审批信息',
            visible: true,
          },
        ],
      };
    },
    computed: {
      formColumn() {
        return [
          {
            prop: 'ruleNo',
            name: '规则编号',
            type: 'input',
            span: 8,
          },
          {
            prop: 'ruleCompanyName',
            name: '公司',
            type: 'input',
            span: 8,
          },
          {
            prop: 'ruleName',
            name: '规则名称',
            type: 'input',
            span: 8,
          },
          {
            prop: 'validDate',
            name: '规则有效期',
            type: 'input',
            span: 8,
          },
          {
            prop: 'auditStatus',
            name: '审核状态',
            type: 'input',
            span: 8,
          },
          {
            prop: 'effectiveStatus',
            name: '生效状态',
            type: 'input',
            span: 8,
          },
          {
            prop: 'createPersonName',
            name: '创建人',
            type: 'input',
            span: 8,
          },
          {
            prop: 'gmtCreate',
            name: '创建时间',
            type: 'input',
            span: 8,
          },
          {
            prop: 'remark',
            name: '备注',
            type: 'input',
            span: 8,
          },
        ];
      },
      operateType() {
        return this.$route.query.type;
      },
    },
    methods: {
      getRuleDetail(id) {
        this.$axios.get(API.COMMISSION_DETAIL + '/' + id).then((res) => {
          console.log(res, '112344');
          if (res.data.code === 0) {
            const data = res.data.data || {};
            const baseInfo = {
              ruleNo: data.ruleNo || 'ruleNo',
              ruleCompanyName: data.ruleCompanyName || 'ruleCompanyName',
              ruleName: data.ruleName || 'ruleName',
              validDate: `${data.validDateFrom.replaceAll(
                '-',
                '.'
              )}-${data.validDateUntil.replaceAll('-', '.')}`,
              auditStatus: this.transferSelect(data.auditStatus || '', this.auditStatusList),
              effectiveStatus: this.transferSelect(
                data.effectiveStatus || '',
                this.effectiveStatusList
              ),
              remark: data.remark || '备注',
              createPersonName: data.createPersonName || 'createPersonName',
              gmtCreate: data.gmtCreate || 'gmtCreate',
            };
            Object.assign(this.baseFormData, baseInfo);
            this.commissionTableData = data.commissionRuleSpaces || [];
            this.commissionRuleData = data.commissionRuleLines || [];
            if (this.commissionRuleData.length > 0) {
              this.commissionRuleData.map((item) => {
                item.rule = item.monthNumber
                  ? `${item.monthNumber}个月租金的${item.percentage}%`
                  : '暂无数据';
              });
            }
            this.auditRecordData = data.commissionRuleAuditRecords || [];
          }
        });
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      cancel() {
        // this.$router.go(-1);
        this.returnPath();
      },
      approval() {
        if (!this.auditInfo.info) {
          return this.$message({
            showClose: true,
            message: '请填写审批信息！',
            type: 'error',
          });
        }
        const params = {
          id: this.id,
          info: this.auditInfo.info,
        };
        this.$axios
          .post(`${API.COMMISSION_AUDIT}/${this.id}/pass?info=${this.auditInfo.info}`, params)
          .then((res) => {
            console.log(res, '1111111');
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            }
          });
      },
      reject() {
        if (!this.auditInfo.info) {
          return this.$message({
            showClose: true,
            message: '请填写审批信息！',
            type: 'error',
          });
        }
        const params = {
          id: this.id,
          info: this.auditInfo.info,
        };
        this.$axios
          .post(`${API.COMMISSION_AUDIT}/${this.id}/reject?info=${this.auditInfo.info}`, params)
          .then((res) => {
            console.log(res, '1111111');
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            }
          });
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/commission/overview',
            name: 'commissionOverview',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .commission-box {
    margin-bottom: 20px;
    .commission-title {
      height: 40px;
      line-height: 40px;
      margin-bottom: 15px;
    }
  }
  .title {
    font-size: 20px;
    font-weight: 600;
  }
  .btns {
    margin-top: 20px;
  }
</style>
